import { Lock } from 'lucide-react';
import { useSession } from '@/auth/use-session';
import { EmptyState } from './empty-state';

/** A page the person's role does not include (Step 15). The API refuses it as well. */
export function NoAccess({ what = 'this page' }: { what?: string }) {
  const session = useSession();
  return (
    <EmptyState
      icon={Lock}
      title="No access"
      description={`Your role${session.roleName ? ` (${session.roleName})` : ''} does not include ${what}. Ask an admin if you need it.`}
    />
  );
}
